import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { ChoiceDialogComponent } from './container/choice-dialog/choice-dialog.component';
import { IChoice, IChoiceDialogData } from './models/choice';

@Injectable({ providedIn: 'root' })
export class DialogService {
    private readonly __matDialog = inject(MatDialog);

    showChoice<T>(choices: IChoice<T>[], title?: string): Observable<T | undefined> {
        return this.__matDialog
            .open<ChoiceDialogComponent<T>, IChoiceDialogData<T>, T>(
                ChoiceDialogComponent,
                {
                    data: { title, choices },
                    autoFocus: 'first-tabbable',
                },
            )
            .afterClosed();
    }
}
